import * as React from 'react'
import moment from 'moment'
import type { Moment } from 'moment'
import { useVehicleForm } from '../../context/VehicleFormContext'
import { DateField } from '@/ui/form/controls/DateField'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'

const DatesStage = () => {
  const { data, setData } = useVehicleForm()
  const { t } = useLocalize()

  const formatDateForField = (
    date: Moment | string | null | undefined,
  ): string | null => {
    if (!date) return null
    if (moment.isMoment(date)) return date.format('YYYY-MM-DD')
    const m = moment(date as string)
    return m.isValid() ? m.format('YYYY-MM-DD') : null
  }

  const parseDateFromField = (dateStr: string | null): Moment | null => {
    if (!dateStr) return null
    const momentDate = moment(dateStr, 'YYYY-MM-DD')
    return momentDate.isValid() ? momentDate : null
  }

  return (
    <div className="tw-flex tw-justify-between">
      <div className="tw-flex-1">
        <p className="tw-text-lg tw-font-semibold tw-text-content-base">
          {t('vehicleModule.dates')}
        </p>
      </div>
      <div className="tw-flex tw-flex-1 tw-flex-col tw-gap-4">
        <DateField
          label={t('vehicleBasics.purchase-date')}
          value={formatDateForField(data?.purchaseDate)}
          setValue={(e) =>
            setData({ ...data, purchaseDate: parseDateFromField(e) })
          }
        />
        <DateField
          label={t('vehicleBasics.sale-date')}
          value={formatDateForField(data?.saleDate)}
          setValue={(e) =>
            setData({ ...data, saleDate: parseDateFromField(e) })
          }
        />
        <DateField
          label={t('vehicleBasics.checkup-date')}
          value={formatDateForField(data?.checkupDate)}
          setValue={(e) =>
            setData({ ...data, checkupDate: parseDateFromField(e) })
          }
        />
        <DateField
          label={t('vehicleBasics.calibration-date')}
          value={formatDateForField(data?.calibrationDate)}
          setValue={(e) =>
            setData({ ...data, calibrationDate: parseDateFromField(e) })
          }
        />
        <DateField
          label={t('vehicleBasics.next-calibration-date')}
          value={formatDateForField(data?.nextCalibrationDate)}
          setValue={(e) =>
            setData({ ...data, nextCalibrationDate: parseDateFromField(e) })
          }
        />
        <DateField
          label={t('vehicleBasics.insurance-validity-date')}
          value={formatDateForField(data?.insuranceValidityDate)}
          setValue={(e) =>
            setData({ ...data, insuranceValidityDate: parseDateFromField(e) })
          }
        />
      </div>
    </div>
  )
}

export default DatesStage
